<!--<greco-locked-videos-page [user]="user$ | async"></greco-locked-videos-page>-->
<greco-user-event-videos-page [user]="user$ | async"></greco-user-event-videos-page>
